import DisplayDocument from "../components/DisplayDocument";

const React = require("react");

const {DisplayDateDetailedAdmin} = require("../../../../../../dumb/DisplayData");
import getCountryName from "../utils/getCountryName";

export const COMPANY_DATA = [
  {
    title: 'Company Name',
    dataKey: 'company_name',
  },
  {
    title: 'Registration Name',
    dataKey: 'reg_number',
  },
  {
    title: 'Nature of business',
    dataKey: 'nature',
  },
  {
    title: 'Business Address',
    dataHandler: ({register_zip, register_country, register_city, register_street, register_address}) => (
      [
        register_zip,
        getCountryName(register_country),
        register_city,
        register_street,
        register_address
      ].join(', ')
    )
  },
  {
    title: 'Operating Address',
    dataHandler: ({operating_zip, operating_country, operating_city, operating_street, operating_address}) => (
      [
        operating_zip,
        getCountryName(operating_country),
        operating_city,
        operating_street,
        operating_address
      ].join(', ')
    )
  },
  {
    title: 'Business Registration Document',
    dataHandler: ({business_registration_extract_doc}) => {
      return (
        <DisplayDocument {...business_registration_extract_doc} />
      )
    }
  },
  {
    title: 'Operating Address Document',
    dataHandler: ({operating_address_doc}) => {
      return (
        <DisplayDocument {...operating_address_doc} />
      )
    }
  },
  {
    title: 'Structure Document',
    dataHandler: ({structure_doc}) => {
      return (
        <DisplayDocument {...structure_doc} />
      )
    }
  },
];

const USER_DATA = [
  {
    title: 'Full Name',
    dataKey: 'full_name',
  },
  {
    title: 'Date of Birth',
    dataHandler: ({birthdate}) => <DisplayDateDetailedAdmin date={birthdate} />
  },
  {
    title: 'Country of Residence',
    dataHandler: ({country_of_residence}) => getCountryName(country_of_residence),
  },
  {
    title: 'Country of Birth',
    dataHandler: ({country_of_birth}) => getCountryName(country_of_birth),
  },
  {
    title: 'Identity Document',
    dataKey: 'identity_doc',
  },
  {
    title: 'Identity Document',
    dataHandler: ({identity_doc_data}) => {
      return (
        <DisplayDocument {...identity_doc_data} />
      )
    }
  },
  {
    title: 'Address Document',
    dataHandler: ({address_doc_data}) => {
      return (
        <DisplayDocument {...address_doc_data} />
      )
    }
  }
]

export const PROFILE_DATA = [
  {
    title: 'Profile Type',
    dataHandler: ({profile_type}) => {
      const profileTypes = {
        account_holder: 'Holder',
        director_holder: 'Holder & Director',
        director: 'Director',
      }
      return profileTypes[profile_type] || '';
    },
  },
  ...USER_DATA
]
export const OWNER_DATA = [
  {
    title: 'Profile Type',
    dataHandler: () => 'Business Owner',
  },
  ...USER_DATA,
  {
    title: '% of shares',
    dataHandler: ({owner_percent}) => `${owner_percent}%`,
  }
];
